module.exports = __webpack_public_path__ + "static/img/yq-monitor.130f8e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/yq-monitor.svg
// module id = 2xej
// module chunks = 7